import React, { useEffect, useState } from 'react';
import { connect, useDispatch, useSelector } from 'react-redux';
import * as actions from 'redux/actions/index';
import Loader from 'react-loader-spinner';
import { Confirm } from 'react-st-modal';
import './custom.css';
import { PLATFORM_TYPE, SUBSCRIPTION_TYPE } from 'Utility/constants';

const CurrentPlan = (props) => {
   const dispatch = useDispatch();
   let expiry;
   let nickname, amount, interval, dollar, slash;
   let isCancelAllowed = false;
   debugger;
   if (props.subdata && props.subdata.subscription) {
      if (props.subdata.subscription_platform === PLATFORM_TYPE.admin) {
         nickname = 'Lifetime Membership';
         amount = null;
         interval = null;
         dollar = null;
         slash = null;
      } else if (props.subdata.subscription_platform === PLATFORM_TYPE.stripe) {
         isCancelAllowed = true;
         nickname = props.subdata.subscription.meta.plan.nickname;
         amount = props.subdata.subscription.meta.plan.amount / 100;
         interval = props.subdata.subscription.meta.plan.interval;
         dollar = '$';
         slash = '/';
      } else {
         // iOS and Android
         if (
            props.subdata.subscription_type ===
            SUBSCRIPTION_TYPE.monthly.type
         ) {
            nickname = SUBSCRIPTION_TYPE.monthly.plan;
            amount = SUBSCRIPTION_TYPE.monthly.price;
            interval = SUBSCRIPTION_TYPE.monthly.interval;
            dollar = '$';
            slash = '/';
         } else {
            nickname = SUBSCRIPTION_TYPE.yearly.plan;
            amount = SUBSCRIPTION_TYPE.yearly.price;
            interval = SUBSCRIPTION_TYPE.yearly.interval;
            dollar = '$';
            slash = '/';
         }
      }
   }

   const confirmationHandler = async (e) => {
      e.preventDefault();

      const result = await Confirm(
         'This action cannot be undone. Are you sure you want to cancel the subscription?',
         'Cancel Subscription',
         'Confirm',
         'Cancel'
      );
      if (result) {
         dispatch(actions.cancelSub());
      }
   };

   let isLoading = useSelector((state) => state.authReducer.isLoading);

   useEffect(() => {
      if (!props.subdata) {
         dispatch(actions.getSub());
      }
   }, [props.subdata, dispatch]);

   if (
      props.subdata &&
      props.subdata.subscription &&
      props.subdata.subscription_platform !== 'admin'
   ) {
      let options = {
         year: 'numeric',
         month: 'long',
         day: 'numeric',
      };
      expiry = new Date(
         parseInt(props.subdata.subscription.expires_date_ms)
      ).toLocaleDateString('en-US', options);
   } else if (
      props.subdata &&
      props.subdata.subscription &&
      props.subdata.subscription_platform === 'admin'
   ) {
      expiry = 'Not Applicable';
   } else expiry = null;

   let status;
   if (props.subdata && props.subdata.subscription_status === 'active_paid') {
      status = 'Active';
   } else if (
      props.subdata &&
      props.subdata.subscription_status === 'active_trial'
   ) {
      status = 'Free Trial';
   } else {
      status = 'Not Subscribed';
   }

   return (
      <div id="wrap">
         <section class="ihWeb_sec theme_nav_mt">
            <div class="container">
               <div class="row">
                  <div class="col-md-10 col-lg-7 mx-auto">
                     <div class="card ihWeb_card">
                        <div class="card-body">
                           <article class="ihWeb_art">
                              <h3 class="border-bottom mb-0 pb-2">
                                 Subscription Details
                              </h3>
                           </article>
                           <form class="ihWeb_form" id="profile_form">
                              <fieldset class="mt-3">
                                 <div class="row align-items-center mb-2 ">
                                    <div class="col-lg-6">
                                       <h4 class="mb-0">Plan Information</h4>
                                    </div>

                                    <div class="col-lg-6">
                                       <div class="form-group">
                                          <h4 class="mb-0">{nickname}</h4>
                                          <h5 class="mb-0">
                                             {dollar}
                                             {amount}
                                             {slash}
                                             {interval}
                                          </h5>
                                       </div>
                                    </div>
                                 </div>
                                 <div class="row align-items-center mb-2">
                                    <div class="col-lg-6">
                                       <h4 class="mb-0">Expiry Date</h4>
                                    </div>
                                    <div class="col-lg-6">
                                       <div class="form-group">
                                          <h4 class="mb-0">{expiry}</h4>
                                       </div>
                                    </div>
                                 </div>
                                 <div class="row align-items-center mb-2">
                                    <div class="col-lg-6">
                                       <h4 class="mb-0">Status Plan</h4>
                                    </div>

                                    <div class="col-lg-6">
                                       <div class="form-group">
                                          <h4 class="mb-0">{status}</h4>
                                       </div>
                                    </div>
                                 </div>
                                 {isCancelAllowed && (
                                    <div className="row">
                                       <div className="col-sm-12">
                                          <div className="subscribe_btn_wrp text-center">
                                             <button
                                                disabled={
                                                   isLoading ? true : false
                                                }
                                                type="submit"
                                                className="theme_btn theme_primary"
                                                onClick={confirmationHandler}
                                             >
                                                {isLoading ? (
                                                   <Loader
                                                      type="Circles"
                                                      color="#FFF"
                                                      height={25}
                                                      width={110}
                                                   />
                                                ) : (
                                                      'Cancel Plan'
                                                   )}
                                             </button>
                                          </div>
                                       </div>
                                    </div>
                                 )}
                              </fieldset>
                           </form>
                        </div>
                     </div>
                  </div>
               </div>
            </div>
         </section>
      </div>
   );
};

const mapStateToProps = (state) => {
   return {
      user: state.authReducer.user,
      subdata: state.authReducer.subdata,
   };
};

export default connect(mapStateToProps)(CurrentPlan);
